<template>
  <h1>this is Celebrity Page</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>